import { render, staticRenderFns } from "./ClientDefault.vue?vue&type=template&id=364dc5b7&"
import script from "./ClientDefault.vue?vue&type=script&lang=ts&"
export * from "./ClientDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports